import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faEye } from "@fortawesome/free-solid-svg-icons";
import { Checkbox, Select } from "../../../form-inputs/inputs";

const orderList = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
    { value: "4", text: "4" },
];

const sharedColumns = [
    {
        Header: "Description",
        accessor: "description",
    },
    {
        Header: "Manufacturer",
        accessor: "manufacturer",
    },
    {
        Header: "Brand",
        accessor: "brand",
    },
    {
        Header: "Product Line",
        accessor: "line",
    },
    {
        Header: "Age in Days",
        accessor: "age",
    },
    {
        Header: "UPC",
        accessor: "upc",
    },
    {
        Header: "Category",
        accessor: "category",
    },
];
export const searchRefColumns = (toggleSelection) => {
    return [
        {
            Header: "Add",
            Cell: (rowInfo) => {
                return (
                    <Checkbox
                        name={`checkbox_search_${rowInfo.index}`}
                        value={rowInfo.original.isChecked}
                        updateOnChange={(key, value) => {
                            toggleSelection(value, rowInfo.original);
                        }}
                    />
                );
            },
        },
        ...sharedColumns,
        {
            Header: "",
            Cell: (rowInfo) => {
                return (
                    <button style={{ display: "none" }} className="button -small">
                        <FontAwesomeIcon icon={faEye} />
                    </button>
                );
            },
        },
    ];
};

export const currentRefColumns = (removeReference, updateCompareOrder) => {
    return [
        {
            Header: "Order",
            accessor: "order",
            Cell: (rowInfo) => {
                return (
                    <Select
                        name={`order_list_${rowInfo.original.key}`}
                        value={rowInfo.value}
                        options={orderList}
                        updateOnChange={(key, value) => {
                            updateCompareOrder(value, rowInfo.original);
                        }}
                    />
                );
            },
        },
        ...sharedColumns,
        {
            Header: "",
            accessor: "add",
            Cell: (rowInfo) => {
                return (
                    <div>
                        <button
                            className="button -small"
                            onClick={() => {
                                removeReference(rowInfo.original);
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                        <button style={{ display: "none" }} className="button -small">
                            <FontAwesomeIcon icon={faEye} />
                        </button>
                    </div>
                );
            },
        },
    ];
};
